import Axios  from 'axios';
import store  from '../store';
import Router from '../router';

/**
 * SHOP
 * CONTROL DE BASE_URL DE FRONTVIEW PARA LA VISTA PUBLICA DE LA TIENDA
 * 
*/
const HttpConfig = function(token = '') {

    let axios = Axios.create({

        //baseURL: 'http://127.0.0.1:8000/api/shop/',                              // SERVIDOR LOCAL HOST
        //baseURL: 'https://boletos.zumbashop.mx/services/public/api/shop/',  //Servidor de Desarrollo
         baseURL: 'https://zumbashop.mx/service/public/api/shop/',         // SERVIDOR DE PRODUCCIÓN
        
        headers: {
            'Authorization': `Bearer ${token}`
        }

    });

    axios.interceptors.response.use(
        function(response) {
            return response;
        },
        function(error) {

            if (error.response.status === 403) {
                store.dispatch("logout");
                Router.push({ name: "login" });
                console.log('Error Of Token :: Config');
            } else {
                return Promise.reject(error);
            }

        }
    );

    return axios;
}

export default HttpConfig;
